export default function DownloadCTA() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20gradient%20abstract%20background%20with%20coral%20and%20soft%20golden%20amber%20tones%2C%20organic%20flowing%20shapes%2C%20modern%20digital%20art%20style%2C%20smooth%20transitions%2C%20clean%20minimal%20composition%2C%20no%20text&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-950/40 to-background-950/80"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
          随时随地，发现精彩
        </h2>
        <p className="text-sm md:text-base text-background-50/75 mb-8 max-w-lg mx-auto leading-relaxed">
          下载红桃视频App，畅享高清短视频体验。个性化推荐、流畅播放，
          海量精彩内容等你来发现。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="w-full sm:w-auto px-10 py-4 bg-background-50 text-foreground-950 text-sm font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
            <i className="ri-apple-fill text-lg"></i>
            App Store 下载
          </button>
          <button className="w-full sm:w-auto px-10 py-4 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
            <i className="ri-android-fill text-lg"></i>
            Android 下载
          </button>
        </div>

        <p className="text-xs text-background-50/50 mt-6">
          适用于 iOS 15+ 和 Android 8+ 系统
        </p>
      </div>
    </section>
  );
}